import { render } from "./ListItemBadge.vue?vue&type=template&id=32219505"
import script from "./ListItemBadge.vue?vue&type=script&lang=js"
export * from "./ListItemBadge.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__